import { defineMessages } from 'react-intl';

export default defineMessages({
  search: {
    id: 'view.appBar.bottomBar.search',
    defaultMessage: 'Search',
  },
  scan: {
    id: 'view.appBar.bottomBar.scan',
    defaultMessage: 'Scan',
  },
});
